import { useParams } from "react-router-dom";

const adminParams = [
  "setId",
  "portalId",
  "groupId",
  "resourceId",
  "userId",
  "adminId",
  "progressCourseId",
  "itemId",
  "clientId",
  "courseSessionId",
];

const useAdminParams = () => {
  const parsedParams = useParams();

  for (const param in parsedParams) {
    if (adminParams.includes(param) && !!parsedParams[param])
      parsedParams[param] = parseInt(parsedParams[param]);
  }

  const { courseId, licenceId } = parsedParams;

  if (courseId !== "all" && !/\d+::\d+/.test(courseId) && !!courseId)
    parsedParams.courseId = parseInt(courseId);

  if (!["overview", "all"].includes(licenceId) && !!licenceId)
    parsedParams.licenceId = parseInt(licenceId);

  return parsedParams;
};

export default useAdminParams;
